import { useEffect, useState } from "react";
import { useStateStore } from "@/store";
import ourImg1 from "@/assets/our/img1.png";
import ourImg2 from "@/assets/our/img2.png";
import ourImg3 from "@/assets/our/img3.png";
import ourImg4 from "@/assets/our/img4.png";
import ourImg5 from "@/assets/our/img5.png";
import ourImg6 from "@/assets/our/img6.png";
import ourImg7 from "@/assets/our/img7.png";
import ourImg8 from "@/assets/our/img8.png";
import ourImg9 from "@/assets/our/img9.png";
import ourImg10 from "@/assets/our/img10.png";
import ourImg11 from "@/assets/our/img11.png";
import ourImg12 from "@/assets/our/img12.png";
import ourImg13 from "@/assets/our/img13.png";
import ourImg14 from "@/assets/our/img14.png";
import ourImg15 from "@/assets/our/img15.png";
import ourImg16 from "@/assets/our/img16.png";
import ourImg17 from "@/assets/our/img17.png";
import ourImg18 from "@/assets/our/img18.png";
import ourImg19 from "@/assets/our/img19.png";
import ourImg20 from "@/assets/our/img20.png";
import ourImg21 from "@/assets/our/img21.png";
import ourImg22 from "@/assets/our/img22.png";
import ourImg23 from "@/assets/our/img23.png";
import "./index.scss";

const PartnersWrap = () => {
  const state = useStateStore();
  const { appType } = state.default;
  const [tableLogo, setTableLogo] = useState([]);
  const [bannerImgStyle, setBannerImgStyle] = useState({});
  const [currentIndex, setCurrentIndex] = useState(1);
  const arr = [
    ourImg1,
    ourImg2,
    ourImg3,
    ourImg4,
    ourImg5,
    ourImg6,
    ourImg7,
    ourImg8,
    ourImg9,
    ourImg10,
    ourImg11,
    ourImg12,
    ourImg13,
    ourImg14,
    ourImg15,
    ourImg16,
    ourImg17,
    ourImg18,
    ourImg19,
    ourImg20,
    ourImg21,
    ourImg22,
    ourImg23,
  ];
  const arrLength = [1, 2, 3];

  const table_logo_computed = (start, end) => {
    let newLogo = [];
    if (end > 0) {
      newLogo = arr.slice(start, end);
    } else {
      newLogo = arr.slice(start);
    }
    console.log(newLogo, "newLogo");
    setTableLogo(newLogo);
  };
  const handleBannerIndex = (newBannerIndex) => {
    if (newBannerIndex > 3 || newBannerIndex < 1) {
      return false;
    }
    setBannerImgStyle({
      opacity: 1,
    });
    let styleTime = setTimeout(() => {
      setBannerImgStyle({
        opacity: 1,
        animation: "imgNoneOrDisplay 1s ease-in-out forwards",
      });
    }, 100);
    if (appType === "pad") {
      if (newBannerIndex === 1) {
        table_logo_computed(0, 9);
      } else if (newBannerIndex === 2) {
        table_logo_computed(9, 18);
      } else if (newBannerIndex === 3) {
        table_logo_computed(18);
      }
    } else if (appType === "phone") {
      if (newBannerIndex === 1) {
        table_logo_computed(0, 8);
      } else if (newBannerIndex === 2) {
        table_logo_computed(8, 16);
      } else if (newBannerIndex === 3) {
        table_logo_computed(16);
      }
    }

    setCurrentIndex(newBannerIndex);
    clearTimeout(styleTime);
  };
  useEffect(() => {
    handleBannerIndex(currentIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appType]);
  return (
    <div className="partners-wrap">
      <div className="partners-vertical"></div>
      <h1 className="partners-wrap-title">Our partners</h1>
      {/* pc */}
      {appType === "pc" && (
        <div className="partners-pc-wrap">
          {arr.map((item, index) => {
            return (
              <div className="partners-pc-box">
                <img key={index} src={item} alt="" />
              </div>
            );
          })}
        </div>
      )}
      {/* table */}
      {appType !== "pc" && (
        <div className="partners-table-wrap">
          <div
            className="arrow-common"
            onClick={() => {
              handleBannerIndex(currentIndex - 1);
            }}
          >
            <img
              src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/shiku/1692326848264_arrow.svg"
              alt=""
            />
          </div>
          <div className="partners-pc-wrap" style={bannerImgStyle}>
            {tableLogo.map((item, index) => {
              return (
                <div className="partners-pc-box">
                  <img key={index} src={item} alt="" />
                </div>
              );
            })}
          </div>
          <div
            className="arrow-common"
            onClick={() => {
              handleBannerIndex(currentIndex + 1);
            }}
          >
            <img
              src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/shiku/1692326848259_arrow (1).svg"
              alt=""
            />
          </div>
        </div>
      )}
      <ul className="partners-table-dian">
        {arrLength.map((item) => {
          return (
            <li
              key={item}
              className={currentIndex === item ? "li_active" : ""}
              onClick={() => {
                handleBannerIndex(item);
              }}
            ></li>
          );
        })}
      </ul>
    </div>
  );
};

export default PartnersWrap;
